module.exports = __webpack_public_path__ + "img/sodexo.b70c1821.png";